module.exports = __webpack_public_path__ + "img/29.e38ee90c.jpg";